import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Constants from '../constants'
import course from './course'
import favorite from './favorite'
import genre from './genre'
import plan from './plan'
import place from './place'
import route from './route'
import station from './station'
import location from './location'
import translation from './translation'
import notice from './notice'
import ticket from './ticket'
import axios from 'axios'

Vue.use(VueCookies)

// jestでaxiosはmockにするのでその時はセットしない
if (axios.defaults) {
  var env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
  axios.defaults.baseURL = Constants.API_BASE_URL_LIST[env_key]
  axios.defaults.responseType = 'json'
}

const api = {
  ...course,
  ...genre,
  ...favorite,
  ...plan,
  ...place,
  ...route,
  ...station,
  ...location,
  ...translation,
  ...notice,
  ...ticket
}

export default api
